import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type LiveMapService from 'garaje/services/live-map-v2';
import type { Amenity, Floor, Neighborhood, Resource, ResourceType } from 'garaje/types/maps/live-map/LiveMapServiceV2';
import { routeEvent } from 'garaje/utils/decorators/route';

// TODO: add extra types needed to populate the map here
export interface ExternalMapControllerModelType {
  resources: Resource[];
  resourceTypes: ResourceType[];
  floors: Floor[];
  neighborhoods: Neighborhood[];
  amenities: Amenity[];
  companyName: string | null;
  draftName: string | null;
  locationId: string | null;
}

function isShareExpiredError(error: unknown): error is { payload: { status: number } } {
  return (error as { payload: { status: number }[] }).payload[0]?.status === 404;
}

export default class ExternalMapLiveRoute extends Route {
  @service declare router: RouterService;
  // @ts-expect-error
  @service('live-map-v2') declare liveMapV2: LiveMapService;

  async fetchLiveMapData(shareToken: string): Promise<void> {
    try {
      // Populate data in livemapv2 service
      await this.liveMapV2.getUpdatedExternalLiveMapData(shareToken);
    } catch (error: unknown) {
      this.liveMapV2.stopPolling();
      this.liveMapV2.willDestroy();

      if (isShareExpiredError(error)) {
        this.router.transitionTo('link-expired');
      }
    }
  }

  async model({ share_token }: { share_token: string }): Promise<ExternalMapControllerModelType> {
    if (!share_token) {
      this.router.transitionTo('link-expired');
    }

    await this.fetchLiveMapData(share_token);

    return {
      resources: this.liveMapV2.resources,
      resourceTypes: this.liveMapV2.resourceTypes,
      floors: this.liveMapV2.floors,
      neighborhoods: this.liveMapV2.neighborhoods,
      amenities: this.liveMapV2.amenities,
      companyName: this.liveMapV2.companyName,
      draftName: this.liveMapV2.draftName,
      locationId: this.liveMapV2.locationId,
    };
  }

  @routeEvent
  routeWillChange(): void {
    this.liveMapV2.willDestroy();
  }
}
